<template>
	<div>
		<v-dialog v-model="showdialog" hide-overlay transition="dialog-bottom-transition" scrollable fullscreen>
			<v-card class="turizem-search-model-card">
				<div class="turizem-search-top" dense floating>
					<input
						placeholder="Search"
						class="turizem-search-input"
						v-model="search_turisem_points"
						@input="filterTurisemPoints"
					/>
					<v-btn class="turizem-search-close" flat icon @click="closeModalSearch()">
						<v-icon color="primary">close</v-icon>
					</v-btn>
				</div>

				<div class="turizem-search-list-wrapper">
					<template v-for="(item, index) in filterTurisemPoints()">
						<div
							v-if="index % 2 == 0"
							class="turizem-search-list-item"
							:key="index"
							avatar
							@click="goTurisemDetail(item.id)"
						>
							<img v-if="item.image != ''" :src="item.image" />
							<div class="turizem-search-list-title" v-html="item.title"></div>
						</div>
						<div
							v-if="index % 2 == 1"
							class="turizem-search-list-item turizem-search-list-item-2"
							:key="index"
							avatar
							@click="goTurisemDetail(item.id)"
						>
							<img v-if="item.image != ''" :src="item.image" />
							<div class="turizem-search-list-title" v-html="item.title"></div>
						</div>
					</template>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import map_helper from '@/config/js_helper/map_helper';

export default {
	name: 'TurisemDialog',
	props: {
		list_turistic_point: {
			type: [Array, Object],
			required: true,
		},
		showdialog: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			search_turisem_points: '',
		};
	},
	computed: {
		dialog_search: function () {
			return this.$store.state.other_dialog_active;
		},
	},
	watch: {
		showdialog(show) {
			if (show) {
				this.$store.state.active_loader = false;
			}
		},
	},
	methods: {
		filterTurisemPoints() {
			var temp = this.search_turisem_points;
			if (temp != '') {
				return this.list_turistic_point.filter(function (el) {
					return el.title.toLowerCase().match(temp.toLowerCase());
				});
			} else {
				return this.list_turistic_point;
			}
		},
		closeModalSearch() {
			this.search_turisem_points = '';
			this.$router.back();
		},
		goTurisemDetail(id) {
			this.$store.commit('setOtherDialogActivity', false);
			map_helper.goTurisemDetail(parseInt(id), false);
		},
	},
};
</script>

<style lang="scss" scoped>
.turizem-search-model-card {
	border: none !important;
	.turizem-search-top {
		background-color: #f9f9f9;
		margin: 0 !important;
		padding: 16px !important;
		box-shadow: none;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: auto;
		.turizem-search-input {
			border-radius: 25px;
			background-color: white;
			flex: 1 auto;
			padding: 10px 16px;
		}
		.turizem-search-close {
			position: absolute;
			right: 25px;
			border-radius: 0%;
			margin: 0;
			.v-icon {
				font-size: 30px;
			}
		}
	}
	.turizem-search-list-wrapper {
		background-color: #f9f9f9;
		display: flex;
		flex-wrap: wrap;
		padding: 16px;
		.turizem-search-list-item {
			background-color: white;
			width: 120px;
			border-radius: 10px;
			flex: 1 1 auto;
			position: relative;
			height: 250px;
			margin-bottom: 20px;
			img {
				border-radius: 10px;
				object-fit: cover;
				width: 100%;
				height: 100%;
			}
			.turizem-search-list-title {
				font-size: 18px;
				text-shadow: 0px 0px 20px black;
				font-weight: 700;
				position: absolute;
				bottom: 15px;
				color: white;
				right: 15px;
				left: 15px;
				line-height: 20px;
			}
			//margin-bottom: 20px;
			&:nth-child(odd) {
				margin-right: 10px;
			}
			&:nth-child(even) {
				margin-left: 10px;
			}
			&:last-child {
				max-width: calc(50% - 10px) !important;
			}
		}
		.turizem-search-list-item-2 {
			//margin-top: 30px;
		}
	}
}
</style>
